module.exports = __webpack_public_path__ + "static/media/zopsmartlogo.b67443c6.svg";